export default "__VITE_ASSET__BpD$j0pM__"